import { lazy } from "react";
import { enumPermisosCorresponsalMovii } from "./enumPermisosCorresponsalMovii";
import { enumPermisosCorresponsalTransfiya } from "./enumPermisosCorresponsalMovii";
/** Componente de iconos */
const AppIcons = lazy(() => import("../../components/Base/AppIcons"));
/**
 * Movii
 */
const CorresponsalMovii = lazy(() => import("./CorresponsalMovii"));
const DepositoTransfiya = lazy(() => import("./Views/TransfiYa/DepositoTransfiya"));
const CobroTransfiya = lazy(() => import("./Views/TransfiYa/CobroTransfiya"));
const RetiroTransfiya = lazy(() => import("./Views/TransfiYa/RetiroTransfiya"));
const MoviiPDPCashIn = lazy(() => import("./Views/Movii/DepositoMovii"));
const MoviiPDPCashOut = lazy(() => import("./Views/Movii/RetiroMovii"));
const listPermissionMovii = Object.values(enumPermisosCorresponsalMovii);
const listPermissionTransfiya = Object.values(enumPermisosCorresponsalTransfiya);

export const listPermissionsMovii = listPermissionMovii;
export const listPermissionsTransfiya = listPermissionTransfiya;

const rutasMoviiTransfiya = {
  link: "/transfiya",
  label: <AppIcons Logo={"TRANSFIYA"} name='Pay-Ya' />,
  component: CorresponsalMovii,
  permission: listPermissionsTransfiya,
  subRoutes: [
    {
      link: "/transfiya/deposito",
      label: <AppIcons Logo={"MOVII_RETIRO"} name='PayIn - Meter Plata' />,
      component: DepositoTransfiya,
      permission: [enumPermisosCorresponsalTransfiya.TRANSFIYA_DEPOSITO],
    },
    {
      link: "/transfiya/cobro",
      label: <AppIcons Logo={"MOVII_RETIRO"} name='Cobro Pay-Ya' />,
      component: CobroTransfiya,
      permission: [enumPermisosCorresponsalTransfiya.TRANSFIYA_COBRO],
    },
    {
      link: "/transfiya/retiro",
      label: <AppIcons Logo={"MOVII_RETIRO"} name='PayOut - Sacar Plata' />,
      component: RetiroTransfiya,
      permission: [enumPermisosCorresponsalTransfiya.TRANSFIYA_RETIRO],
    },
  ],
};

export const rutasMovii = {
  link: "/movii-pdp",
  label: <AppIcons Logo={"MOVII"} name='Movii' />,
  component: CorresponsalMovii,
  permission: listPermissionsMovii,
  subRoutes: [
    {
      link: "/movii-pdp/deposito",
      label: <AppIcons Logo={"MOVII_RETIRO"} name='Depósito' />,
      component: MoviiPDPCashIn,
      permission: [enumPermisosCorresponsalMovii.MOVII_DEPOSITOS],
    },
    {
      link: "/movii-pdp/retiro",
      label: <AppIcons Logo={"MOVII_RETIRO"} name='Retiro' />,
      component: MoviiPDPCashOut,
      permission: [enumPermisosCorresponsalMovii.MOVII_RETIROS],
    },
  ],
};

export default rutasMoviiTransfiya;